import React from 'react';
import Highlight from 'react-highlighter';

const Highlighter = (props: { value: string, searchTerm: string }) => {
    const searchTermList = props.searchTerm.split(' ');
    const searchTermListUpdated:Array<string> = [];
    searchTermList.forEach((term:string) => { searchTermListUpdated.push(`(${term})`)});
    const searchTermRegexString = searchTermListUpdated.join('|');
    const stringTermRegex = new RegExp(`${searchTermRegexString}`, 'i');
    return <Highlight matchElement="span" matchClass="highlighted-text" search={stringTermRegex}>{props.value}</Highlight>;
}

export default Highlighter;
